import React from 'react';
import { useClickAway } from 'react-use';

import { useCXI } from 'modules/cxi/useCXI';
import * as Styled from './StyledContainer';

export const ContainerSlim = ({ children, ...props }) => {
    const { setModal } = useCXI();

    const containerRef = React.useRef(null);

    useClickAway(containerRef, () => {
        setModal(null);
    });

    return (
        <Styled.ContainerSlim {...props} ref={containerRef}>
            <Styled.Close onClick={() => setModal(null)}>
                <span className="icon far fa-times" aria-hidden="true" />
            </Styled.Close>

            {children}
        </Styled.ContainerSlim>
    );
};
